import { Box, Typography } from '@mui/material';
import React from 'react';

type FilterLineLabelProps = {
  isFirstLine: boolean;
};

export const FilterLineLabel: React.FC<FilterLineLabelProps> = React.memo(({ isFirstLine }) => (
  <Box>
    <Typography
      variant="body2"
      sx={{
        fontSize: '14px',
        width: '60px',
        fontWeight: 500,
        color: '#666',
      }}
    >
      {isFirstLine ? 'Where' : 'And'}
    </Typography>
  </Box>
));
